var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppContext } from '../contexts/AppContextProvider';
import { Button } from '../components';
import { validateForm } from '../utils/inputValidation';
import { FormField } from './FormField';
export var Form = function () {
    var _a = useState(''), loadingClass = _a[0], setLoadingClass = _a[1];
    var _b = useAppContext(), activeStep = _b.activeStep, errorMessage = _b.errorMessage, formData = _b.formData, setErrorMessage = _b.setErrorMessage, setFormData = _b.setFormData, stepHistory = _b.stepHistory, appConfig = _b.appConfig, setSuccessMessage = _b.setSuccessMessage, handleActiveStep = _b.handleActiveStep;
    var formFields = appConfig.forms[activeStep].fields;
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var errorMessages, payload, url, response, data, errorStepMessage, successStepMessage, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    errorMessages = validateForm(formData, appConfig);
                    if (errorMessages) {
                        setErrorMessage(errorMessages);
                        return [2 /*return*/];
                    }
                    payload = __assign(__assign({}, formData), { history: stepHistory, url: appConfig.url, userAgent: navigator.userAgent, hmac: appConfig.hmac, countryCode: appConfig.countryCode, country: appConfig.country, timestamp: appConfig.timestamp });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    setLoadingClass('loading');
                    url = (_a = appConfig.forms[activeStep]) === null || _a === void 0 ? void 0 : _a.appUrlSendFormData;
                    if (!url) {
                        throw new Error('Missing URL for form submission.');
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _b.sent();
                    errorStepMessage = appConfig.forms[activeStep].errorMessage || data.error;
                    successStepMessage = appConfig.forms[activeStep].successMessage || 'Data has been sent.';
                    if (!response.ok) {
                        switch (response.status) {
                            case 400:
                                setErrorMessage(errorStepMessage);
                                break;
                            case 401:
                                setErrorMessage(appConfig.translations.unauthorizedError);
                                break;
                            case 500:
                                setErrorMessage(appConfig.translations.serverError);
                                break;
                            default:
                                setErrorMessage(data.error);
                                break;
                        }
                        throw new Error(errorMessage);
                    }
                    setLoadingClass('');
                    setErrorMessage('');
                    setSuccessMessage(successStepMessage);
                    setFormData({
                        email: '',
                        phone: '',
                        zip: '',
                        message: '',
                    });
                    handleActiveStep('submitted');
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Error during form submission:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field, index) { return (_jsx(FormField, { field: field }, index)); }), errorMessage && _jsx("div", __assign({ className: "error-message" }, { children: errorMessage })), _jsx(Button, { buttonType: "submit", additionalClass: loadingClass })] })));
};
